// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"48":"4c54ba27","101":"56cc6be9"}[chunkId] + ".chunk.css";
};